// extracted by mini-css-extract-plugin
export default {"heroSection":"FaitWalletView_heroSection__Br8BA","sectionOne":"FaitWalletView_sectionOne__2a1Q2","sectionThree":"FaitWalletView_sectionThree__Y6nCk"};